import { ReactComponent as AttachmentIcon } from 'presentation/assets/icons/attachment-icon.svg'
import { SchedulesRow } from 'presentation/hospital/layouts/Home/Ambulatory'
import Button from 'presentation/shared/components/Button'
import { ChipLabel } from 'presentation/shared/components/StatusChip/styles'
import React, { useState } from 'react'
import ContactRegistrationModal from '../ContactRegistrationModal'
import * as S from './styles'

type Props = {
  schedule?: SchedulesRow
}

export function AmbulatoryScheduleHeader({ schedule }: Props) {
  const [openContactRegistration, setOpenContactRegistration] =
    useState<boolean>(false)
  return (
    <>
      <S.FirstLine>
        <ChipLabel color="golden" fontSize="small">
          Realizado
        </ChipLabel>
        <S.RightButtons>
          <S.AttachmentButton>
            <AttachmentIcon />
            Contém anexo
          </S.AttachmentButton>
          <Button
            variant="outlined"
            style={{ padding: '10px', height: '40px' }}
            onClick={() => setOpenContactRegistration(true)}
          >
            Registrar observação
          </Button>
        </S.RightButtons>
      </S.FirstLine>
      {openContactRegistration ? (
        <ContactRegistrationModal
          onClose={() => setOpenContactRegistration(false)}
          ambulatory_schedule_id={schedule?.ambulatory_schedule_id}
          patient_id={schedule?.patient_id}
        />
      ) : null}
    </>
  )
}
